import React, { useState, useEffect } from "react";
import { useNetworkStatus } from "react-adaptive-hooks";
import Link from "next/link";
import styles from "./AboutVideo.module.css";
import { ArrowRight } from "lucide-react";
import Image from "next/image";

interface Data {
  campus_video: {
    id: string;
    label: string;
    url: string;
  };
  card_with_link: {
    link: {
      label: string;
      url: string;
    };
    title_description: {
      description: string;
      title: string;
    };
  };
  cover_image: {
    url: string;
    alternativeText: string | null;
  };
}

interface VideoProps {
  className?: string;
  data: Data;
}

const AboutVideo: React.FC<VideoProps> = ({ className, data }) => {
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlay = () => {
    setIsPlaying(true);
  };
  const videoURL = data?.campus_video?.url || "";
  const videoId = videoURL.split("v=")[1];

  const { effectiveConnectionType } = useNetworkStatus();

  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return null;
  }
  return (
    <div
      className={`${styles.aboutVideoSection} ${
        className ? styles.contactVideoBg : ""
      }`}
    >
      <div className="container">
        <div className={styles.videoContent}>
          <h2>{data?.card_with_link?.title_description?.title}</h2>
          {effectiveConnectionType === "4g" && data?.campus_video?.url ? (
            <>
              {!isPlaying && (
                <div className={styles.cover} onClick={handlePlay}>
                  <div className={styles.overlay}></div>
                  <Image
                    src={data?.cover_image?.url}
                    alt={data?.cover_image?.alternativeText || ""}
                    title={data?.cover_image?.alternativeText || ""}
                    width={1224}
                    height={380}
                    style={{
                      width: 1224,
                      height: 380,
                    }}
                  />
                  <button
                    aria-label="Play Button"
                    className={styles.playButton}
                  >
                    ▶
                  </button>
                </div>
              )}
              {isPlaying && (
                <div className={styles.videoBanner}>
                  <iframe
                    className={styles.youtubeVideo}
                    src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&modestbranding=1&controls=1&amp;&rel=0&showinfo=0&iv_load_policy=3&fs=1&disablekb=1`}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    sandbox="allow-forms allow-scripts allow-pointer-lock allow-same-origin"
                  ></iframe>
                </div>
              )}
            </>
          ) : (
            <div style={{ margin: 20 }}>
              <Image
                src={data?.cover_image?.url}
                alt={
                  data?.cover_image?.alternativeText || "About section Video"
                }
                title={
                  data?.cover_image?.alternativeText || "About section Video"
                }
                width={1224}
                height={380}
                className={styles.videoImage}
              />
            </div>
          )}

          <p>{data?.card_with_link?.title_description?.description}</p>
          {data?.card_with_link?.link !== null ? (
            <Link
              href={data?.card_with_link?.link?.url}
              target="_blank"
              rel="norel"
              title={data?.card_with_link?.link?.label}
            >
              {data?.card_with_link?.link?.label}
              <ArrowRight />
            </Link>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

export default AboutVideo;
